import { Component, OnInit } from '@angular/core';
import { AllOrderList, CustomerAllOrderListVM, OrderListVM } from 'src/app/models/customer/customer.model';
import { PagingModel } from 'src/app/models/paging/paging.model';
import { CustomerService } from 'src/app/services/customer.service';
import { Router,ActivatedRoute,Params } from '@angular/router';
import { ProductService } from 'src/app/services/product.service';
import { CustomerOrderStatus } from 'src/app/Enums/order';
import { count } from 'console';
import { stat } from 'fs';
import { HomePageService } from 'src/app/services/home-page.service';
import { ProductResponseModel,ProductModel } from 'src/app/models/Home/home-list.model';
import { AlertifyService } from 'src/app/services/Common/alertify.service';

@Component({
  selector: 'app-customer-order-list',
  templateUrl: './customer-order-list.component.html',
  styleUrls: ['./customer-order-list.component.css']
})
export class CustomerOrderListComponent implements OnInit {
 
  orderListsVm: OrderListVM = new OrderListVM();
  pagingModel: PagingModel;
  Loader: boolean = false;
  totalPages: number;
  pageNumber: number = 1;
  productId:number;
  orderlist: any;
  startDate:string;
  endDate:string;
  imageLoader: boolean = false;
  maxDate: any = new Date();
  userData: any =[];
  userValues: string = "";
  userSelected: Array<string> = [];
  showStartDateError: boolean = false;
  showEndDateError: boolean = false;
  orderData:any;
  productModel: ProductModel = new ProductModel();

  orderResponseModelTotalLength:any;
  selectedFilter: string;
  customerAllOrderList: AllOrderList = new AllOrderList();
  CustomerOrderStatus: typeof CustomerOrderStatus = CustomerOrderStatus;
  homeProductResponseModel: ProductResponseModel = new ProductResponseModel();

  constructor(private homePageService: HomePageService, private alertify: AlertifyService, private _customerService:CustomerService,private router:Router,private route:ActivatedRoute, private getProductService: ProductService  ) {
    this.orderListsVm = new OrderListVM();
    this.customerAllOrderList  = new AllOrderList();
    this.productModel = new ProductModel();
    this.pagingModel = new PagingModel();
    this.pagingModel.pageNumber = 1;
    if (this.totalPages == undefined || this.totalPages == 0) {
      this.totalPages = 1;
    }
   }

  ngOnInit() {
    this.getProductService.getProductId.subscribe((selectedProductId: any) => {
      this.productId = +selectedProductId;
      console.log("this.productId", this.productId)
    });
     this.customerOrderList();
  }
  onDateChange() {
    this.showStartDateError = Object.prototype.toString.call(this.startDate) === "[object Date]" ? true : false;
  }

  onEndDateChange() {
    this.showEndDateError = Object.prototype.toString.call(this.endDate) === "[object Date]" ? true : false;
  }
  onChangeFilter(value) {
    this.selectedFilter = value;
  }

  resetFilter() {
    this.startDate = "";
    this.endDate = "";
    this.orderListsVm.PageNumber = 1;
    this.orderListsVm.PageSize = 10;
    this.totalPages = 1;
    this.pageNumber = 1;
    this.customerOrderList();
  }

 
  filter() {
    this.showStartDateError = Object.prototype.toString.call(this.startDate) === "[object Date]" ? true : false;
    this.showEndDateError = Object.prototype.toString.call(this.endDate) === "[object Date]" ? true : false;
    this.orderListsVm.PageNumber = 1;
    this.orderListsVm.PageSize = 10;
    this.orderListsVm.StartDate = this.startDate;
    this.orderListsVm.EndDate = this.endDate;
    this.orderListsVm.ProductId= this.productId;
    this.customerOrderList();
  }
  customerOrderList() {
    this.orderListsVm.StartDate = this.startDate;
    this.orderListsVm.EndDate = this.endDate;
    this.Loader = true;
    this._customerService.GetCustomerOrderList(this.orderListsVm)
    .subscribe(response => {
      this.Loader = false;
      var responseBody = JSON.parse(response._body);
      if(responseBody.isSuccess)
      {
        this.customerAllOrderList.CustomerOrdeList = responseBody.responseData;
        this.customerAllOrderList.CustomerOrdeList.forEach((element, index) => {
        this.customerAllOrderList.CustomerOrdeList[index].imageLoader = true;
          this.homePageService.ProductImageList(element.productId)
            .subscribe((response) => {
              let responseimage = JSON.parse(response._body)
              if (responseimage.isSuccess) {
                this.customerAllOrderList.CustomerOrdeList[index].productImage = responseimage.responseData;
                this.customerAllOrderList.CustomerOrdeList[index].imageLoader = false;
                this.imageLoader = false;

              } (err) => {
              }
            })
        });
        this.customerAllOrderList.TotalPages = responseBody.totalPages;
        this.totalPages = this.customerAllOrderList.TotalPages == undefined ? 0 : this.customerAllOrderList.TotalPages;
      } else {
        this.alertify.error(responseBody.responseMessage);
        this.Loader = false;
      }
    });
  }
  
  loadPage(pagingModel: PagingModel) {
    this.orderListsVm.PageNumber = pagingModel.pageNumber;
    this.orderListsVm.PageSize = pagingModel.pageSize;
    this.customerOrderList();
  }
  getOrderDetails(item)
  { 
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/customer-single-order-list/'+ item.id]));
      window.open('#' + url, '_blank');
  }
  

  productImage(item){
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/product-page/' + item.productId]));
      window.open('#' + url, '_blank');
  }

}

